import React from 'react';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';

export interface Props {
  className?: string;
  children: React.ReactNode;
  disabled?: boolean;
  onClick?: () => void;
}

export class GroupOperationButton extends React.Component<Props> {
  render() {
    const { className, children, onClick, disabled } = this.props;
    return (
      <TextButton
        size="small"
        variant="main"
        className={className}
        disabled={disabled}
        onClick={onClick}
      >
        {children}
      </TextButton>
    );
  }
}

export default GroupOperationButton;
